import { SignInButton } from './EmailAuth';
import React, { useCallback } from 'react';
import { UserProfile } from '../services/api';
import { LogOut } from 'lucide-react';
import { Analytics } from '../services/analytics';
import { useNavigate, useLocation } from 'react-router-dom';

interface LoginProps {
  signInLabel?: string;
  userProfile: UserProfile | null;
  setUserProfile: React.Dispatch<React.SetStateAction<UserProfile | null>>;
}

const Login: React.FC<LoginProps> = ({ userProfile, setUserProfile, signInLabel = 'Sign in with' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const tourRequested = new URLSearchParams(location.search).get('welcome') === '1';


  const handleLogout = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(";").forEach(function(c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    setUserProfile(null);
    Analytics.logAuth.signOut();
    navigate(tourRequested ? '/availability?welcome=1' : '/availability', { replace: true });
  }, [setUserProfile, navigate, tourRequested]);

  return (
    <div className="w-full sm:w-auto">
      {userProfile ? (
        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
          <span className="text-sm text-ink-700">
            Welcome, {userProfile.user.first_name || userProfile.googleFirstName || 'User'}!
          </span>
          <button
            onClick={handleLogout}
            className="w-full sm:w-auto flex items-center justify-center px-4 py-2 text-sm font-medium
                     text-red-600 bg-red-50 hover:bg-red-100 rounded-md transition-colors duration-300 space-x-2"
          >
            <LogOut className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      ) : (
        <SignInButton label={signInLabel} onProfileUpdate={setUserProfile} />
      )}
    </div>
  );
};

export default Login;
